<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Loader
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content content--modifier-height" *ngIf="isBrowser">
  <h2>Customized Spinner</h2>
  <div class="content__tools-wrap">
    <div class="content__row">
      <div class="c-input-check-inline">
        <label for="useCase" class="content__row-label">Use Cases</label>
        <select [(ngModel)]="selectedUseCase" class="c-input-group__control" id="useCase">
          <ng-container *ngFor="let useCase of useCases">
            <option [value]="useCase">{{ useCase }}</option>
          </ng-container>
        </select>
      </div>
    </div>
  </div>
</div>
<div class="content">
  <maced-loader *ngIf="selectedUseCase === 'Loading'" loaderId="Loading" loaderLabelId="loaderLabelId"
    label="Loading"></maced-loader>
  <br>
  <maced-loader *ngIf="selectedUseCase === 'Cargando'" loaderId="Cargando" loaderLabelId="loaderLabelId1"
    label="Cargando"></maced-loader>
  <br>
  <maced-loader *ngIf="selectedUseCase === 'प्रगति चालू है'" loaderId="प्रगति" loaderLabelId="loaderLabelId2"
    label="प्रगति चालू है"></maced-loader>
</div>